import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export interface IResourceActionsResult extends IResult {
  resourceActions: Record<string, string[]>;
}

export class GetAllowedResourceActionsForActorRequest extends Request<{}, IResourceActionsResult> {
  constructor() {
    super('getAllowedResourceActionsForActor', {});
  }
}
